"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TestId = void 0;
let TestId = exports.TestId = /*#__PURE__*/ function(TestId) {
    // Address row in billing address
    TestId["AddressRowSkeleton"] = "address-row-skeleton";
    // Basket button in progress bar
    TestId["BasketNavigationButton"] = "basket-navigation-button";
    // Billing address section
    TestId["BillingAddress"] = "billing-address";
    // Billing address disabled because delivery address is not selected
    TestId["BillingAddressDisabled"] = "billing-address-disabled";
    // Billing address header
    TestId["BillingAddressHeader"] = "billing-address-header";
    // Billing address name
    TestId["BillingAddressName"] = "billing-address-name";
    // Billing address skeleton
    TestId["BillingAddressSkeleton"] = "billing-address-skeleton";
    // Billing address title
    TestId["BillingAddressTitle"] = "billing-address-title";
    // Checkout button in progress bar
    TestId["CheckoutNavigationButton"] = "checkout-navigation-button";
    // Loader for suspense when waiting for checkout registration
    TestId["CheckoutRegistrationLoader"] = "checkout-registration-loader";
    // Wrapper for checkout registration
    TestId["CheckoutRegistrationWrapper"] = "checkout-registration-wrapper";
    // Skeleton for Checkout step
    TestId["CheckoutStepSkeleton"] = "checkout-step-skeleton";
    // My information section
    TestId["MyInformation"] = "my-information";
    // My information change message
    TestId["MyInformationChange"] = "my-information-change";
    // My information email address
    TestId["MyInformationEmailAddress"] = "my-information-email-address";
    // My information email address missing message
    TestId["MyInformationEmailAddressMissing"] = "my-information-email-address-missing";
    // My information header
    TestId["MyInformationHeader"] = "my-information-header";
    // My information name
    TestId["MyInformationName"] = "my-information-name";
    // My information phone number
    TestId["MyInformationPhoneNumber"] = "my-information-phone-number";
    // My information phone number missing message
    TestId["MyInformationPhoneNumberMissing"] = "my-information-phone-number-missing";
    // My information skeleton
    TestId["MyInformationSkeleton"] = "my-information-skeleton";
    // My information title
    TestId["MyInformationTitle"] = "my-information-title";
    // Shopping bag owner name skeleton
    TestId["NameSkeleton"] = "name-skeleton";
    // Offers button in progress bar
    TestId["OffersNavigationButton"] = "offers-navigation-button";
    // Skeleton for Offers step
    TestId["OffersStepSkeleton"] = "offers-step-skeleton";
    // Order preview wrapper
    TestId["OrderPreview"] = "order-preview";
    // Order preview on desktop
    TestId["OrderPreviewDesktop"] = "order-preview-desktop";
    // Order preview on mobile
    TestId["OrderPreviewMobile"] = "order-preview-mobile";
    // Skeleton for Summary
    TestId["SummarySkeleton"] = "summary-skeleton";
    // Step wrapper element
    TestId["StepWrapper"] = "step-wrapper";
    // Basket section in delivery step
    TestId["BasketSection"] = "basket-section";
    // Payment section in delivery step
    TestId["PaymentSection"] = "payment-section";
    return TestId;
}({});
